import React from 'react';
import OurClientsSection from '../components/SolutionsSection';

const OurClients = () => {
  return (
    <div>
      <OurClientsSection />
    </div>
  );
};

export default OurClients;